import {
  SAVE_ADDRESS,
  SAVE_ADDRESS_SUCCEED,
  SAVE_ADDRESS_FAILED,
  UPDATE_ADDRESS,
  UPDATE_ADDRESS_SUCCEED,
  UPDATE_ADDRESS_FAILED,
  DELETE_ADDRESS,
  DELETE_ADDRESS_SUCCEED,
  DELETE_ADDRESS_FAILED,
  FETCH_ADDRESS,
  FETCH_ADDRESS_SUCCEED,
  FETCH_ADDRESS_FAILED,
} from './action_types';

export default {
  onSaveAddressAction: (data) => ({
    type: SAVE_ADDRESS,
    params: {
      data,
    },
  }),
  onSaveAddressActionSucceed: (data) => ({
    type: SAVE_ADDRESS_SUCCEED,
    params: {
      data,
    },
  }),
  onSaveAddressActionFailed: (err) => ({
    type: SAVE_ADDRESS_FAILED,
    err,
  }),

  // update
  onUpdateAddressAction: (data) => ({
    type: UPDATE_ADDRESS,
    params: {
      data,
    },
  }),
  onUpdateAddressActionSucceed: (data) => ({
    type: UPDATE_ADDRESS_SUCCEED,
    params: {
      data,
    },
  }),
  onUpdateAddressActionFailed: (err) => ({
    type: UPDATE_ADDRESS_FAILED,
    err,
  }),

  // delete
  onDeleteAddressAction: (data) => ({
    type: DELETE_ADDRESS,
    params: {
      data,
    },
  }),
  onDeleteAddressActionSucceed: (data) => ({
    type: DELETE_ADDRESS_SUCCEED,
    params: {
      data,
    },
  }),
  onDeleteAddressActionFailed: (err) => ({
    type: DELETE_ADDRESS_FAILED,
    err,
  }),

  // fetch
  onFetchAddressAction: (data) => ({
    type: FETCH_ADDRESS,
    params: {
      data,
    },
  }),
  onFetchAddressActionSucceed: (data) => ({
    type: FETCH_ADDRESS_SUCCEED,
    params: {
      data,
    },
  }),
  onFetchAddressActionFailed: (err) => ({
    type: FETCH_ADDRESS_FAILED,
    err,
  }),
};
